import { render, staticRenderFns } from "./Notification__timeCard.vue?vue&type=template&id=2c5213dc&"
import script from "./Notification__timeCard.vue?vue&type=script&lang=js&"
export * from "./Notification__timeCard.vue?vue&type=script&lang=js&"
import style0 from "./Notification__timeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports